<template>
  <div class="extension-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <p class="header-title">My Extension</p>
        <button class="header-button" @click="goRepaymentPage">
          Full Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 20px"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="status-indicator">
          <span class="days-count">{{ extensionInfo.period }}</span>
          <span class="days-label">Extension days</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value"
              >${{ extensionInfo.extensionAccrStr }}</span
            >
            <span class="detail-label">Extension cost</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(extensionInfo.extensionDueDateStr)
            }}</span>
            <span class="detail-label">New due date</span>
          </div>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 内容区域 -->
      <!-- 延期详情卡片 -->
      <div class="card info-card" v-if="extensionInfo.extensionBoolean">
        <!-- <div class="info-row">
          <span>Payment bank</span>
          <div class="bank-info">
            <span>{{ extensionInfo.repaymentBankName }}</span>
          </div>
        </div> -->

        <!-- 银行选择区域 -->
        <!-- <div class="bank-selection">
          <div class="selection-header">
            <h4>Select payment method</h4>
          </div>

          <div class="payment-category" v-for="(methods, category) in bankMethods" :key="category">
            <div class="category-header" @click="toggleCategory(category)">
              <span class="category-title">{{ category === "Métodos de pago" ? "Payment Methods" : category }}</span>
              <span class="toggle-icon">{{ expandedCategories[category] ? '−' : '+' }}</span>
            </div>

            <div v-show="expandedCategories[category]" class="methods-list">
              <div
                  v-for="method in methods"
                  :key="method.repayCode"
                  class="method-item"
                  :class="{ selected: method.selected }"
                  @click="selectMethod(method)"
              >
                <div class="radio-wrapper">
                  <div class="custom-radio" :class="{ checked: method.selected }"></div>
                </div>
                <div class="method-info">
                  <div class="method-name">{{ method.repayMethodName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="info-row">
          <span>Account holder:</span>
          <span>{{ extensionInfo.titular }}</span>
        </div>

        <!-- Extension Payment Button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
            style="width: 100%; max-width: 300px;"
          >
            Extension Payment
          </button>
        </div>
      </div>

      <!-- 无法延期提示 -->
      <div
        class="card info-card"
        style="margin-top: 20px"
        v-if="!extensionInfo.extensionBoolean"
      >
        <p class="no-extension-text">
          You cannot request an extension temporarily
        </p>
      </div>

      <!-- Safe Repayment Reminder -->
      <div
        class="card warning-card"
        v-if="extensionInfo.extensionBoolean"
        style="margin-top: 20px; background-color: #fff9e6; border-left: 4px solid #ffc107;"
      >
        <div style="display: flex; align-items: flex-start;">
          <span style="font-size: 18px; color: #ffc107; margin-right: 10px;"
            >⚠️</span
          >
          <div>
            <p style="font-weight: 600; margin: 0 0 8px 0; color: #333;">
              Safe Repayment Reminder
            </p>
            <p style="margin: 0 0 5px 0; font-size: 14px; color: #333;">
              Always repay using the UPIID shown in this App.
            </p>
            <p style="margin: 0; font-size: 14px; color: #333;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="extensionInfo.extensionBoolean"
        style="margin-top: 20px;"
      >
        <div class="utr-input-container">
          <label class="utr-label">Enter UTR Number</label>
          <p>
            After completing payment, please enter your 12-digit UTR(UPI Ref.
            No.) below ↓
          </p>
          <br />
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR
          </button>
        </div>
      </div>

      <!-- 操作按钮 -->
      <!-- <div class="action-buttons" v-if="extensionInfo.extensionBoolean">
        <button class="primary-btn" @click="copyCLABE">Extension Payment</button>
      </div> -->
    </main>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "ExtensionPage",
  data() {
    return {
      extensionInfo: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      currentDate: "",
      expandedCategories: {},
      lastExpandedCategory: null,
      utr: "", // Add UTR data property
      utrSubmitted: false, // Add UTR submitted flag
      utrSuccessMessage: "", // Add UTR success message
    };
  },
  mounted() {
    document.title = "My Extension";
  },
  created() {
    this.setCurrentDate();
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },
    setCurrentDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${y}-${m}-${d}`;
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getExtensionInfo(
        {
          key: keyStr,
        },
        true,
      );
      this.extensionInfo = res;

      // 获取银行方法
      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        // 转换数据结构
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;

      selectedCategory = categories[0];

      // 查找当前选中的银行所在的分类
      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      // 初始化所有分类为收起状态
      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      // 展开选中银行所在的分类
      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        // 如果没有选中的银行，展开第一个分类
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        // 收起之前展开的分类
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        // 展开新的分类
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      // 重置所有方法的选中状态
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      // 设置当前选中方法
      this.$set(method, "selected", true);

      // 更新还款信息
      this.repaymentCode = method.repayCode;
      // 如果 repayMethodName 包含 "-"，只取前面部分
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.extensionInfo.repaymentBankName = bankName;
    },
    goRepaymentPage() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/repayment", query: { key: keyStr } });
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
            extension: true,
          },
          false,
        );

        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }

        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    // UTR Validation
    isValidUTR() {
      // Check if UTR is exactly 12 digits
      return /^\d{12}$/.test(this.utr);
    },
    // Paste UTR from clipboard
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        // Only paste if it's a 12-digit number
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          // If not a valid UTR, paste anyway but show error
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    // Submit UTR
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: true, // Set to true for extension
          },
          true,
        ); // Using form data

        // Handle response as needed
        console.log("UTR submitted successfully", response);

        // Show toast message for success
        // Assuming there's a toast library available like Vant
        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          // Fallback to alert if no toast library
          alert("Success");
        }

        // Set success state and message
        this.utrSubmitted = true;
        // Use a generic success message or extract from response if available
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";

        // You might want to clear the UTR input after successful submission
        // this.utr = '';

        // Handle any other post-submission logic here
      } catch (error) {
        console.error("Error submitting UTR:", error);
        // Handle error appropriately
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        // Show error toast
        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans",
    "Helvetica Neue", sans-serif;
}

.extension-container {
  min-height: 100vh;
  background-color: #f5f7fa;
  color: #333;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #f5f7fa;
  padding-bottom: 0px;
}

/* 头部样式 */
.header {
  background-color: #003539;
  color: white;
  padding: 16px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  flex: 1;
  text-align: center;
}

.header-button {
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.header-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* 卡片通用样式 */
.card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin: 0 20px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 状态卡片 */
.status-card {
  display: flex;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #003539, #003539);
  color: white;
  margin-top: 10px;
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
}

.days-count {
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
}

.days-label {
  font-size: 13px;
  margin-top: 4px;
}

.status-details {
  flex: 1;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.detail-label {
  font-size: 12px;
  opacity: 0.9;
}

/* 内容区域 */
.content {
  margin: 0 auto;
  padding-bottom: 200px;
}

/* 信息卡片 */
.info-card {
  padding: 10px;
  position: relative;
  margin: 0 20px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

.bank-info {
  display: flex;
  align-items: center;
}

.advice-text {
  margin-bottom: 10px;
  line-height: 1.5;
  color: #5f6368;
}

.no-extension-text {
  text-align: center;
  padding: 16px;
  color: #d93025;
  font-weight: 500;
}

/* Warning Card Styles */
.warning-card {
  padding: 16px;
  margin: 0 20px;
  border-radius: 8px;
}

.warning-card p {
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 16px;
  margin: 0 20px 20px;
}

.utr-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.utr-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
}

.utr-input:focus {
  border-color: #003539;
}

.paste-btn {
  background-color: #f1f3f4;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 15px;
  font-size: 14px;
  cursor: pointer;
}

.paste-btn:hover {
  background-color: #e8eaed;
}

.error-message {
  color: #000000;
  font-size: 14px;
  margin-bottom: 10px;
}

.success-message {
  color: #003539;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 500;
}

.submit-utr-btn {
  width: 100%;
  background-color: #003539;
  color: white;
  border: none;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submit-utr-btn:hover:not(:disabled) {
  background-color: #008055;
}

.submit-utr-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

/* 银行选择区域 */
.bank-selection {
  margin-top: 0px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.selection-header {
  margin-bottom: 15px;
}

.selection-header h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.selection-subtitle {
  font-size: 13px;
  color: #d93025;
  line-height: 1.4;
}

.payment-category {
  margin-bottom: 15px;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.category-header:hover {
  background: #e9ecef;
}

.category-title {
  font-weight: 600;
  color: #444;
  font-size: 14px;
}

.toggle-icon {
  font-weight: bold;
  font-size: 16px;
  color: #666;
}

.methods-list {
  margin-top: 8px;
  border: 1px solid #eee;
  border-radius: 6px;
  overflow: hidden;
}

.method-item {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 1px solid #eee;
}

.method-item:last-child {
  border-bottom: none;
}

.method-item:hover {
  background-color: #f8f9fa;
}

.method-item.selected {
  background-color: #f0f8ff;
  border-left: 3px solid #003539;
}

.radio-wrapper {
  margin-right: 12px;
}

.custom-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  position: relative;
  transition: all 0.2s;
}

.custom-radio.checked {
  border-color: #003539;
  background: #003539;
}

.custom-radio.checked::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.method-info {
  flex: 1;
}

.method-name {
  font-size: 14px;
  color: #333;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-width: 600px;
  margin: 0 auto;
}

.primary-btn {
  flex: 1;
  background-color: #003539;
  color: white;
  border: none;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.primary-btn:hover {
  background-color: #003539;
}

.secondary-btn {
  flex: 1;
  background-color: white;
  color: #003539;
  border: 1px solid #003539;
  border-radius: 24px;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.secondary-btn:hover {
  background-color: #f5f5f5;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .status-card {
    flex-direction: column;
    text-align: center;
  }

  .status-indicator {
    margin-bottom: 16px;
    padding: 0;
  }

  .status-details {
    width: 100%;
  }

  .action-buttons {
    flex-direction: row;
    gap: 12px;
  }

  .primary-btn,
  .secondary-btn {
    width: 100%;
  }

  .card {
    margin: 0 10px 10px;
  }

  .info-card {
    margin: 0 10px;
  }
}
</style>
